import "./Header.scss";
import HelpDropdown from "../HelpDropdown/HelpDropdown.js";
import BurgerMenu from "../BurgerMenu/BurgerMenu.js";
import { Link, NavLink, useNavigate } from "react-router-dom";

import { useContext, useState } from "react";
import { AuthContext } from "../../context/AuthContext";

function Header() {
  const { user, logoutUser } = useContext(AuthContext);
  const navigate = useNavigate();

  const navLinkStyles = ({ isActive }) => {
    return {
      width: isActive ? "100px" : "normal",

      transition: isActive ? "all 5s" : "normal",
      background: isActive ? "#060c89" : "#FFFFFF",
      color: isActive ? "white" : "#000000",
      padding: isActive ? "5px 0" : "normal",
      borderRadius: isActive ? "40px" : "normal",
    };
  };

  const handleLogout = async () => {
    await logoutUser(); // Firebase signOut
    navigate("/login"); // Redirect after logout
  };

  // Help menu
  // const [open, setOpen] = useState(false);

  //************************ */

  return (
    <section className="header">
      <div className="header__container">
        <div>
          <Link to={"/"} className="header__logo-link">
            <h1 className="header__site-name">UnGriefMe</h1>
          </Link>
          {/* <h1 className="header__site-name">UnGriefMe</h1> */}

          <p className="header__tagline">Where Grief Meets Compassion</p>
        </div>
        <BurgerMenu />
        <ul className="header__nav">
          <NavLink to={"/"} className="header__nav-item" style={navLinkStyles}>
            <li>Home</li>
          </NavLink>
          <NavLink
            to={"/stories"}
            className="header__nav-item"
            style={navLinkStyles}
          >
            <li>Stories</li>
          </NavLink>

          <HelpDropdown />

          <NavLink
            to={"/songs"}
            className="header__nav-item"
            style={navLinkStyles}
          >
            <li>Rhythms</li>
          </NavLink>
          <NavLink
            to={"/about"}
            className="header__nav-item"
            style={navLinkStyles}
          >
            <li>About</li>
          </NavLink>

          {!user && (
            <NavLink
              to={"/login"}
              className="header__nav-item"
              style={navLinkStyles}
            >
              <li>Login</li>
            </NavLink>
          )}

          {/* Show Logout only if user IS logged in */}

          {user && (
            <li
              to={"/login"}
              className="header__nav-item-logout"
              onClick={handleLogout}
              style={{ cursor: "pointer" }}
              // style={navLinkStyles}
            >
              Logout
            </li>
          )}
        </ul>
      </div>
    </section>
  );
}

export default Header;
